import Pagination from '@mui/material/Pagination';
import classNames from 'classnames/bind';
import styles from '@/styles/superstack/base/Pagination.module.scss';

export const SSPagination = ({ countItems, paginatiedBy, page, handlePageChange }) => {
  const cx = classNames.bind(styles);
  let count = 0;
  if (countItems) {
    count = parseInt((countItems - 1) / paginatiedBy) + 1;
  }
  return (
    <Pagination
      className={cx('ss-pagination')}
      count={count}
      shape="rounded"
      page={page ? page * 1 : 1}
      onChange={handlePageChange}
    />
  );
};
